// export const ratio = window.devicePixelRatio
export const CommandTypes = {
  LINE_TO: 1,
  MOVE_TO: 2,
  CHANGE_COLOR: 3,
  CHANGE_THICKNESS: 4,
  NEXT_PAGE: 5,
  MARCHING_ANTS: 6,
}

export const TYPE = 0
export const T = 1
export const X = 2
export const Y = 3
export const PRESSURE = 4
export const COLOR = 2

export function scaleCanvas (inputCanvas, width = 1920, height = 1080) {
  const canvas = inputCanvas
  const viewport = [width, height]
  canvas.width = viewport[0] // eslint-disable-line
  canvas.height = viewport[1] // eslint-disable-line
  canvas.style.width = `${viewport[0]}px`
  canvas.style.height = `${viewport[1]}px`
}

// export const fatnessMultiplier = { true: 50, false: 1 }

export function processCommand (ctx, command, { fat }) {
  switch (command[TYPE]) {
    case CommandTypes.LINE_TO:
      ctx.lineTo([command[X], command[Y], command[PRESSURE]])
      break

    case CommandTypes.MOVE_TO:
      ctx.moveTo([command[X], command[Y]])
      break

    // case CommandTypes.CHANGE_THICKNESS: {
    //   if (fat) {
    //     ctx.setStrokeThickness(command[THICKNESS] * fatnessMultiplier[fat])
    //   }
    //   break
    // }

    case CommandTypes.MARCHING_ANTS: {
      if (!fat) {
        ctx.setStrokeColor("white")
        ctx.setMarchingAnts()
      }
      break
    }

    case CommandTypes.CHANGE_COLOR:
      if (fat) {
        ctx.setStrokeColor("black")
      } else {
        ctx.setStrokeColor(command[COLOR])
      }
      break

    default:
      console.warn("unknown command type", command[TYPE])
  }
}



// WEBPACK FOOTER //
// ./src/canvas/helpers.js